import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot } from "@angular/router";

import { Plant } from "@models/Plant";

import { PlantsService } from "./plants.service";

@Injectable()
export class ClassificationReportResolver {
  constructor(private ps: PlantsService) {}

  async resolve(route: ActivatedRouteSnapshot): Promise<Plant> {
    const id = route.params["id"];
    const plant = await this.ps.getClassification(id);
    return plant;
  }
}
